import React from "react";

import ChallengeQuestion from "./ChallengeQuestion";
import Entry from "./Entry";
import OutOfBand from "./OutOfBand";
import Disclosure from "../../Disclosure";

export default {
  entry: Entry,
  challengeQuestion: ChallengeQuestion,
  challengeOutofband: OutOfBand,
  disclosureAccept: Disclosure,
  // memberProfile: () => <Redirect to="/app" />,
  // loginComplete: () => <Redirect to="/app" />,
};



// WEBPACK FOOTER //
// ./src/banking/authentication/Login/steps/index.js